import regexValidator from '@/services/validation/defaultValidators/regex'
import { simpleUrlRegexp } from '@/utils/regexp'

export default (value: unknown) => regexValidator(value, { regex: simpleUrlRegexp })
